import PropTypes from "prop-types";

export const NumberFieldPropTypes = {
  fieldName: PropTypes.string,
  fieldUID: PropTypes.string,
  fieldType: PropTypes.string,
  acceptDecimal: PropTypes.bool,
  required: PropTypes.bool,
  constraints: PropTypes.arrayOf(PropTypes.object),
  validator: PropTypes.array,
  setData: PropTypes.array,
};
